import React, { useState, useEffect, createContext, useContext } from 'react';
import userService from '../../services/userService';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay una sesión guardada al cargar la aplicación
    const initializeAuth = () => {
      try {
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
          const userData = JSON.parse(savedUser);
          setUser(userData);
          console.log('Sesión restaurada:', userData.usuarioNombre);
          console.log('ID Sucursal:', userData.id_sucursal);
        }
      } catch (error) {
        console.error('Error al restaurar sesión:', error);
        // Si hay error, limpiar localStorage corrupto
        localStorage.removeItem('user');
      } finally {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const login = async (usuario, password) => {
    try {
      console.log('Intentando login para usuario:', usuario);
      
      const result = await userService.login(usuario, password);
      
      console.log('Resultado del login:', result);

      if (result.success && result.data) {
        const userData = result.data;
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
        
        console.log('Login exitoso:', userData.usuarioNombre);
        console.log('ID Sucursal asignado:', userData.id_sucursal);
        
        return {
          success: true,
          user: userData,
          message: result.message
        };
      } else {
        console.log('Login fallido:', result.message);
        return {
          success: false,
          message: result.message
        };
      }
    } catch (error) {
      console.error('Error en función login:', error);
      return {
        success: false,
        message: 'Error inesperado durante el login'
      };
    }
  };

  const logout = () => {
    try {
      console.log('Cerrando sesión para:', user?.usuarioNombre);
      setUser(null);
      localStorage.removeItem('user');
      console.log('Sesión cerrada exitosamente');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const isAuthenticated = () => {
    return user !== null;
  };

  const getUserInfo = () => {
    return user;
  };

  const getSucursalId = () => {
    return user?.id_sucursal || null;
  };

  const updateUser = (newUserData) => {
    setUser(newUserData);
    localStorage.setItem('user', JSON.stringify(newUserData));
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated,
    getUserInfo,
    getSucursalId,
    updateUser,
    isLoading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};